import * as t from "io-ts";

import { constants } from "@reactivated/constants";

import { codecFromConstMap } from "./utils";

export const RICH_NAVIGATION_MOBILE_PANEL_ID = "mobile-panel" as const;

export const RichNavigationVariantOptions =
    constants[
        "tsicommon.cms.models.rich_navigation.RichNavigationVariantOptions"
    ];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const RichNavigationVariantOptionsMap = codecFromConstMap(
    "RichNavigationVariantOptions",
    RichNavigationVariantOptions,
);

export type TRichNavigationVariantOptions = t.TypeOf<
    typeof RichNavigationVariantOptionsMap
>;

/** Global BEM class from Wagtail `RichNavigationLinkCollection.variant`. */
export const linkCollectionVariantClass = (variant?: string | null): string =>
    variant ?? RichNavigationVariantOptions.DEFAULT;
